export default __webpack_public_path__ + "static/upbrain-67ca42900b1e65eb72502084ee586f91.jpeg";